import http, { ApiBaseUrl } from "../../http-common";

export default class AdminService {
    static getUsers() { return http.get("/admin/users"); }
    static createUser(data) { return http.post("/admin/users", data); }
    static updateUser(id, data) { return http.put(`/admin/users/${id}`, data); }
    static getStations(path) { return http.get("/admin/stations", { params: { path } }); }
    static updateStationZone(data) { return http.put("/admin/stations/zone", data); }
    static updateStationsZone(data) { return http.put("/admin/stations/zones/bulk", data); }
    static renameStation(data) { return http.put("/admin/stations/rename", data); }
    static deleteStation(data) { return http.delete("/admin/stations", { data }); }
    static deleteStationVersion(id, path) {
        return http.delete(`/versions/${id}`, { data: { path } });
    }
    static getZones() { return http.get("/admin/zones"); }
    static createZone(data) { return http.post("/admin/zones", data); }
    static updateZone(id, data) { return http.put(`/admin/zones/${id}`, data); }
    static deleteZone(id) { return http.delete(`/admin/zones/${id}`); }
    static downloadFullBackup(onDownloadProgress) {
        return http.get("/admin/developer-options/full-backup", {
            responseType: "blob",
            onDownloadProgress
        });
    }
    static downloadFullBackupStream() {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        return fetch(`${ApiBaseUrl}/admin/developer-options/full-backup`, {
            headers: user?.id ? { "X-User-Id": String(user.id) } : {}
        });
    }
}
